import DB from 'offline/db'
import F from 'offline/filter/constants'
import Util from 'offline/util'
// Port of api/fuel/app/classes/filter/package/games/game/data/ratings.php
export default {
	run: function(filter, data, config, global) {
		if (!global.gameIds || !global.gameIds.length || !global.userIndex.length) return

		var rows = []
		if (global.context && global.context.edition && global.context.edition.date_end) {
			var ratingsRaw = {}
			var potentialRatingsRaw = {}
			var key

			if (config.ownerType === F.OWNER_USER) {
				var currentRows = DB.query(
					'SELECT game_id, user_id, rating_value FROM rating WHERE user_id = ' + global.ownerID + ' AND game_id IN(' + Util.in(global.gameIds) + ')'
				)
				for (var ci = 0; ci < currentRows.length; ci++) {
					key = currentRows[ci].user_id + '/' + currentRows[ci].game_id
					ratingsRaw[key] = {
						user_id: currentRows[ci].user_id,
						game_id: currentRows[ci].game_id,
						rating_value: currentRows[ci].rating_value
					}
				}
			}

			var logRows = DB.query(
				'SELECT user_id, game_id, log_rating FROM log_user_rating WHERE user_id IN(' + Util.in(global.userIndex) + ') AND game_id IN(' + Util.in(global.gameIds) + ') AND log_date <= ' + global.context.edition.date_end + ' ORDER BY log_date ASC'
			)

			for (var li = 0; li < logRows.length; li++) {
				key = logRows[li].user_id + '/' + logRows[li].game_id
				potentialRatingsRaw[key] = {
					user_id: logRows[li].user_id,
					game_id: logRows[li].game_id,
					rating_value: logRows[li].log_rating
				}
			}

			var potentialKeys = Object.keys(potentialRatingsRaw)
			for (var pk = 0; pk < potentialKeys.length; pk++) {
				key = potentialKeys[pk]
				if ((parseFloat(potentialRatingsRaw[key].rating_value) || 0) > 0) {
					ratingsRaw[key] = potentialRatingsRaw[key]
				} else {
					delete ratingsRaw[key]
				}
			}

			rows = Object.keys(ratingsRaw).map(function(ratingKey) {
				return ratingsRaw[ratingKey]
			})
		} else {
			rows = DB.query('SELECT game_id, user_id, rating_value FROM rating WHERE game_id IN(' + Util.in(global.gameIds) + ') AND user_id IN(' + Util.in(global.userIndex) + ')')
		}

		global.ratings = global.ratings || {}
		for (var i = 0; i < rows.length; i++) {
			var r = rows[i]
			if (!global.ratings[r.game_id]) global.ratings[r.game_id] = {}
			global.ratings[r.game_id][r.user_id] = r.rating_value
		}

		if (global.ownerType === F.OWNER_BUDDIES) {
			var buddyRows = DB.query(
				'SELECT game_id, rating_value FROM rating WHERE user_id = ' + global.ownerID + ' AND game_id IN(' + Util.in(global.gameIds) + ')'
			)
			global.buddyRatings = {}
			for (var bi = 0; bi < buddyRows.length; bi++) {
				global.buddyRatings[buddyRows[bi].game_id] = buddyRows[bi].rating_value
			}
		}
	}
}
